import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Link, Redirect } from 'react-router-dom';

import {
  Page,
  LoadingPage
} from '../shared';

import ReviewSnapshot from './reviewSnapshot';

import {
  navPrefix,
  isProduction,
} from '../../util';

import {
  getFormattedQuarterFromDate,
  currentlyInQuarterForDate,
} from '../../util/quarters';

import {
  getIcon
} from '../../util/icons';

import {
  fetchSalesCompetencyReviewItems,
  fetchSalesCompetencyReviewsForSeller,
  initializeSalesCompetencyReview,
} from '../../actions/salesCompetencyReviews';

class PredictiveSkillsReview extends Component {

  state = {
    employeeId: null,
    isOwnReview: true,
    previewingReview: 'latest',
    redirectToEdit: null,
  }

  sellerId(){
    return this.state.employeeId || this.props.user.uid;
  }

  initializeReview(){
    this.props.initializeSalesCompetencyReview(this.sellerId(), initializedReview => {
      this.setState({
        redirectToEdit: initializedReview._id,
      });
    });
  }

  renderEmptyState(){

    const isFirstReview = _.size(this.props.salesCompetencyReviewsData) === 0;

    return (
      <React.Fragment>
        <h1>Sales Competencies Review</h1>
        <div className="empty-state-icon">{getIcon('competencies')}</div>
        {this.isOwnReview() &&
          <React.Fragment>
            <p className="state-description">Review your sales competencies with your manager 1-2 times each year to get personalized deal coaching and track your improvement over time.{!isFirstReview && ' Have your manager initiate a Sales Competency Review to get started.'}</p>
            {isFirstReview &&
              <button onClick={() => { this.initializeReview(); }} className="button blue-button begin-review">Begin Your First Review</button>
            }
          </React.Fragment>
        }
        {!this.isOwnReview() &&
          <React.Fragment>
            <p className="state-description">Review sales competencies for {this.sellerName()} 1-2 times each year to get personalized coaching advice and track their improvement over time.</p>
            <button onClick={() => { this.initializeReview(); }} className="button blue-button begin-review">Begin New Review</button>
          </React.Fragment>
        }
      </React.Fragment>
    );
  }
  renderBeginNextReviewCallout(){
    return (
      <div className="begin-next-review-callout">
        <div className="message">Ready for {moment().format('YYYY qQ').toUpperCase()} Sales Competency Review</div>
        <div
          onClick={() => { this.initializeReview(); }}
          className="begin">Begin Review</div>
      </div>
    )
  }

  renderDefaultView(){

    const reviews = _.orderBy(this.props.salesCompetencyReviewsData, 'startedOn', 'desc');
    const hasReviewHistory = _.size(reviews) > 1;

    const latestReview = _.head(reviews);

    const {
      previewingReview
    } = this.state;

    if(!previewingReview){
      return null;
    }

    const previewingReviewStatus = previewingReview.status;
    const previewingReviewIncomplete = previewingReviewStatus !== 'complete';
    const previewingReviewCurrentPartyStatus = previewingReview[this.isOwnReview() ? 'sellerStatus' : 'reviewerStatus'];
    const previewingReviewOtherPartyStatus = previewingReview[this.isOwnReview() ? 'reviewerStatus' : 'sellerStatus'];

    const previewingReviewPriorReview = reviews[_.findIndex(reviews, previewingReview) + 1] || null;

    console.log('previewingReviewPriorReview: ', previewingReviewPriorReview);

    return (
      <div className="reviews-summary">
        {!this.isOwnReview() && !currentlyInQuarterForDate(latestReview.startedOn) && this.renderBeginNextReviewCallout()}
        <div className="reviews-list">
          {_.map(reviews, review => {

            const reviewStatus = review.status;
            const currentPartyStatus = review[this.isOwnReview() ? 'sellerStatus' : 'reviewerStatus'];
            const otherPartyStatus = review[this.isOwnReview() ? 'reviewerStatus' : 'sellerStatus'];

            console.log('rendering sales competency review w/ key: ', review._id);

            return (
              <div
                key={`${review._id}-${review.startedOn}`}
                className={`review-item ${previewingReview === review ? 'selected' : ''}`}
                onClick={() => { this.setState({ previewingReview: review }); }}
              >
                <div className="review-icon">{getIcon('talents')}</div>
                <div className="review-date">{getFormattedQuarterFromDate(review.startedOn)}</div>
                <div className={`review-status ${reviewStatus}`}>
                  {currentPartyStatus === 'notstarted' && 'NOT STARTED'}
                  {currentPartyStatus === 'inprogress' && 'IN PROGRESS'}
                  {reviewStatus !== 'complete' && currentPartyStatus === 'complete' && 'RESULTS PENDING'}
                  {reviewStatus === 'complete' && 'COMPLETE'}
                </div>
              </div>
            )
          })}
        </div>
        <div className="review-detail">
          <h2>{getFormattedQuarterFromDate(previewingReview.startedOn)} Sales Competency Review Snapshot</h2>
          {previewingReviewIncomplete && previewingReviewCurrentPartyStatus === 'notstarted' &&
            <div className="review-pending">Review not complete. Click the button below to begin...</div>
          }
          {previewingReviewIncomplete && previewingReviewCurrentPartyStatus === 'inprogress' &&
            <div className="review-pending">Review in progress. Click the button below to continue editing...</div>
          }
          {previewingReviewIncomplete && previewingReviewCurrentPartyStatus === 'complete' &&
            <div className="review-pending">You have completed this review. Results pending {this.isOwnReview() ? 'manager' : 'seller'} completion.</div>
          }
          {!previewingReviewIncomplete &&
            <div className="review-results">
              <ReviewSnapshot
                sellerInfo={this.props.viewingUser || this.props.user}
                isOwnReview={this.isOwnReview()}
                review={previewingReview}
                priorReview={previewingReviewPriorReview}
              />
            </div>
          }
          <div className="review-actions">
            {this.isOwnReview() && previewingReviewCurrentPartyStatus === 'inprogress' &&
              <Link to={`${navPrefix()}/salesCompetencies/edit/${previewingReview._id}`}><button className="button blue-button">Continue Review...</button></Link>
            }
            {this.isOwnReview() && previewingReviewCurrentPartyStatus === 'notstarted' &&
              <Link to={`${navPrefix()}/salesCompetencies/edit/${previewingReview._id}`}><button className="button blue-button">Begin Self-Review...</button></Link>
            }
            {!this.isOwnReview() && previewingReviewCurrentPartyStatus === 'inprogress' &&
              <Link to={`${navPrefix()}/salesCompetencies/edit/${previewingReview._id}`}><button className="button blue-button">Continue Review...</button></Link>
            }
            {!this.isOwnReview() && previewingReviewCurrentPartyStatus === 'notstarted' &&
              <Link to={`${navPrefix()}/salesCompetencies/edit/${previewingReview._id}`}><button className="button blue-button">Begin Review...</button></Link>
            }
            {previewingReviewStatus === 'complete' &&
              <Link to={`${navPrefix()}/salesCompetencies/view/${previewingReview._id}`}><button className="button button-sm grey-outline full-width">View full report</button></Link>
            }
          </div>
        </div>
      </div>
    )
  }

  isOwnReview(){
    return this.state.isOwnReview;
  }

  renderReviewHome(){
    if(_.size(this.props.salesCompetencyReviewsData) > 0){
      return this.renderDefaultView();
    }
    else{
      return this.renderEmptyState();
    }
  }

  getPriorReviewForReview(review){
    const dateOrderedReviews = _.orderBy(this.props.salesCompetencyReviewsData, reviewData => {
      return reviewData.createdOn;
    });

    console.log('dateOrderedReviews: ', dateOrderedReviews);

    const reviewIndex = _.findIndex(dateOrderedReviews, { _id: review._id });

    if(reviewIndex !== undefined && dateOrderedReviews[reviewIndex + 1]){
      return dateOrderedReviews[reviewIndex + 1];
    }
    else{
      return null;
    }
  }

  sellerName(){
    if(this.state.isOwnReview){
      return (this.props.user || {}).firstName || 'myself';
    }
    else{
      return (this.props.viewingUser || {}).firstName || 'this person';
    }
  }

  // reloadAndViewResultsForLatestReview(){
  //   this.props.fetchSalesCompetencyReviewsForSeller(this.sellerId(), reviews => {
  //     this.setState({
  //       editingReview: null,
  //       previewingReview: reviews[0],
  //       viewingReview: reviews[0],
  //     });
  //   });
  // }

  render(){

    const loading = !this.props.organization || !this.props.salesCompetencyReviewsData;

    const {
      editingReview,
      viewingReview,
      isOwnReview,
      redirectToEdit,
    } = this.state;

    //redirect if initiating view or edit of a review
    if(redirectToEdit){ return <Redirect to={`${navPrefix()}/salesCompetencies/edit/${redirectToEdit}`} /> }

    return (
      <Page pageClass="sales-competency-review" loading={loading}>
        {this.renderReviewHome()}
      </Page>
    )
  }

  componentWillMount(){
    const { match: { params } } = this.props;

    const userIdToFetchReviewsFor = params.employeeId || this.props.user.uid;

    this.setState({
      employeeId: userIdToFetchReviewsFor,
      isOwnReview: !params.employeeId,
    });

    this.props.fetchSalesCompetencyReviewItems();
    this.props.fetchSalesCompetencyReviewsForSeller(userIdToFetchReviewsFor, reviews => {
      this.setState({
        previewingReview: (reviews || [])[0] || null
      });
    });
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    viewingUser: state.viewingUser.data,
    editingUser: state.editingUser,
    organization: state.organization.data,
    salesCompetencyReviewsData: state.salesCompetencyReviews.data,
  }
}

export default connect(mapStateToProps, { fetchSalesCompetencyReviewItems, fetchSalesCompetencyReviewsForSeller, initializeSalesCompetencyReview })(PredictiveSkillsReview);



// WEBPACK FOOTER //
// ./src/components/salesCompetencies/index.js